/* eslint-disable import/no-unused-modules */
import axios from '../requester';
import { LINB_API } from '../constants/api-urls';

export const getIssueTypes = async ({
  sensor_authorization_id,
  limit = 0,
  is_parent = false
} = {}) => {
  return await axios.post(LINB_API.PM_PROJECTS.FILTERS.ISSUE_TYPES, {
    sensor_authorization_id,
    ...(limit > 0 && { limit }),
    ...(is_parent && { is_parent })
  });
};

export const getIssueTypesByIds = async ({
  sensor_authorization_id,
  issues_ids = []
} = {}) => {
  return await axios.post(LINB_API.PM_PROJECTS.FILTERS.ISSUE_TYPES_BY_IDS, {
    sensor_authorization_id,
    issues_ids
  });
};

export const getEntities = async ({
  sensor_authorization_id,
  entity_type,
  keyword,
  limit = 0,
  offset
} = {}) => {
  return await axios.post(LINB_API.PM_PROJECTS.FILTERS.ENTITIES, {
    sensor_authorization_id,
    entity_type,
    ...(keyword && { keyword }),
    limit,
    offset
  });
};
